import { organisationsAPI } from './organisations';
import { getCurrentUser } from './session';

/**
 * Resolve current user's organisation ID (for tree APIs).
 * Uses getCurrentUser().organisationId, or first org from organisationsAPI.list() if missing.
 */
export async function getOrgId() {
  const user = getCurrentUser();
  if (user?.organisationId) return user.organisationId;
  const orgs = await organisationsAPI.list();
  return orgs?.[0]?.id ?? null;
}
